import { type LocaleInput } from '@fullcalendar/core';

const en: LocaleInput = {
	code: 'en',
	firstDay: 0,
	direction: 'ltr',
	buttonText: {
		prev: 'prev',
		next: 'next',
		prevYear: 'prev year',
		nextYear: 'next year',
		year: 'year',
		today: 'today',
		month: 'month',
		week: 'week',
		day: 'day',
		list: 'list'
	},
	weekText: 'W',
	allDayText: 'all-day',
	moreLinkText: 'more',
	noEventsText: 'No events to display'
};

const it: LocaleInput = {
	code: 'it',
	firstDay: 1,
	buttonText: {
		prev: 'Prec',
		next: 'Succ',
		today: 'Oggi',
		month: 'Mese',
		week: 'Settimana',
		day: 'Giorno',
		list: 'Agenda'
	},
	weekText: 'Sm',
	allDayText: 'Tutto il giorno',
	moreLinkText: n => {
		return `+altri ${n}`;
	},
	noEventsText: 'Non ci sono eventi da visualizzare'
};

export default [en, it];
